import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Modal, Button, Form, Row, Col, Spinner, Alert, Ratio } from "react-bootstrap";
import useApi from "../../hooks/useApi";
import { useAuth } from "../../context/AuthContext";
import AuthModals from "../../component/AuthModals";
import Swal from "sweetalert2";
import { useCart } from "../../context/CartContext";
import { useCartDrawer } from "../../context/CartDrawerContext";

const ProductDetails = () => {
  const { slug } = useParams();
  const { bearerAuth } = useApi();
  const { user } = useAuth();

  const {
    addToCart
  } = useCart();
  
    const { openCart } = useCartDrawer();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [showModal, setShowModal] = useState(false);          // booking modal
  const [showLogin, setShowLogin] = useState(false);          // auth modal: login
  const [showRegister, setShowRegister] = useState(false);    // auth modal: register
  const [pendingBooking, setPendingBooking] = useState(false); // remember intent

  // Booking states
  const [bookingLoading, setBookingLoading] = useState(false);
  const [bookingError, setBookingError] = useState("");
  const [bookingSuccess, setBookingSuccess] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [contact, setContact] = useState({
    contact_name: "",
    contact_phone: "",
    contact_email: "",
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    zipcode: "",
  });

  const didFetch = useRef(false);



  useEffect(() => {
    const fetchProduct = async () => {
      if (!slug) return;
      try {
        setLoading(true);
        setError("");
        const res = await bearerAuth(`product?slug=${encodeURIComponent(slug)}`);
        const p = res?.data?.data ?? res?.data ?? null;
        setProduct(p && typeof p === "object" ? p : null);
      } catch (err) {
        console.error(err);
        setError(err?.response?.data?.message || err?.message || "Failed to load product");
      } finally {
        setLoading(false);
      }
    };

    if (didFetch.current) return;
    didFetch.current = true;
    fetchProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  // If user logs in while we were waiting, open booking modal & clear pending flag
  useEffect(() => {
    if (user && pendingBooking) {
      setShowLogin(false);
      setShowRegister(false);
      setPendingBooking(false);
      setShowModal(true);
    }
  }, [user, pendingBooking]);

  

  const handleBook = async (e) => {
    e.preventDefault();
    if (!product?.id) return;

    // extra guard
    if (!user) {
      setShowModal(false);
      setPendingBooking(true);
      setShowLogin(true);
      return;
    }

    setBookingError("");
    setBookingSuccess("");

    const q = Math.max(1, parseInt(quantity || 1, 10));
    try {
      setBookingLoading(true);
      const payload = {
        product_id: product.id,
        quantity: q,
        ...Object.fromEntries(Object.entries(contact).filter(([_, v]) => v !== "" && v != null)),
      };
      const res = await bearerAuth(`product/book`, "POST", payload );

      const ok = res?.data?.status === true;
      if (!ok) throw new Error(res?.data?.message || "Booking failed");

      Swal.fire({
        icon: "success",
        title: "Product booking confirmed",
        text: res?.data?.message || "Product booked successfully",
        timer: 2200,
        showConfirmButton: false,
        timerProgressBar: true,
        position: "top-end",
        toast: true,
      });

      setBookingSuccess(res?.data?.message || "Product booked successfully");
      setShowModal(false);
      // optimistic stock update
      if (typeof product?.stock === "number") {
        setProduct((prev) => (prev ? { ...prev, stock: Math.max(0, prev.stock - q) } : prev));
      }
    } catch (err) {
      console.error(err);
      setBookingError(err?.response?.data?.message || err?.message || "Booking failed");
    } finally {
      setBookingLoading(false);
    }
  };

  const title = product?.title || "Product";
  const description = product?.description || "";
  const price = product?.price ? `${product.currency || ""} ${product.price}` : "";
  const stock = product?.stock ?? "N/A";
  const sku = product?.sku || "";

  return (
    <>
      {loading && (
        <div className="text-center py-3">
          <Spinner animation="border" />
        </div>
      )}
      {error && (
        <Alert variant="danger" className="text-center">
          {error}
        </Alert>
      )}

      {!loading && !error && (
        <section className="service-details pt-100 pb-70">
          <div className="auto-container">
            <div className="row clearfix">
              {/* LEFT: image gallery */}
              <div className="col-lg-5 col-md-12 mb-4">
                <div className="" style={{ top: 90 }}>
                  <Ratio aspectRatio="1x1" className="mb-3">
                    <div
                      style={{
                        borderRadius: 12,
                        overflow: "hidden",
                        border: "1px solid #e9ecef",
                        background: "#f8f9fa",
                      }}
                    >
                      <img
                        src={product?.image && product.image !== "null"
                              ? `${process.env.REACT_APP_IMAGE_URL}/${product.image}`
                              : `${process.env.PUBLIC_URL}/assets/images/service/service-1.jpg`}
                        alt={title}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        onError={(e) => {
                          e.currentTarget.src = `${process.env.PUBLIC_URL}/assets/images/service/placeholder.png`;
                        }}
                      />
                    </div>
                  </Ratio>

                  {/* Thumbnails */}
                  {/* {images.length > 1 && (
                    <div className="d-flex gap-2 flex-wrap">
                      {images.map((src, i) => (
                        <button
                          key={src + i}
                          onClick={() => setActiveIdx(i)}
                          type="button"
                          aria-label={`Show image ${i + 1}`}
                          className={`p-0 border-0`}
                          style={{
                            outline: activeIdx === i ? "2px solid #0d6efd" : "1px solid #e9ecef",
                            borderRadius: 10,
                            overflow: "hidden",
                            width: 72,
                            height: 72,
                            cursor: "pointer",
                            background: "transparent",
                          }}
                        >
                          <Image
                            src={src}
                            alt={`Thumbnail ${i + 1}`}
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            onError={(e) => {
                              e.currentTarget.src = `${process.env.PUBLIC_URL}/assets/images/service/placeholder.png`;
                            }}
                          />
                        </button>
                      ))}
                    </div>
                  )} */}
                </div>
              </div>

              {/* RIGHT: details + actions */}
              <div className="col-lg-7 col-md-12 content-side">
                <div className="service-details-content">
                  <div className="content-one mb-4">
                    <div className="upper-text">
                      <h2 className="mb-3">{title}</h2>
                      {price && <p className="mb-1"><strong>Price:</strong> {price}</p>}
                      {sku && <p className="mb-1"><strong>SKU:</strong> {sku}</p>}
                      <p className="mb-3"><strong>Stock:</strong> {stock}</p>
                      {description && <p className="mb-0">{description}</p>}
                    </div>

                    <div className="book-btn mt-4 d-flex gap-2">
                      <Button
                        variant="primary"
                        className="theme-btn btn-five"
                         onClick={() => {
                      addToCart(product);
                      openCart();
                      // Swal.fire({ icon: "success", title: "Added to cart", timer: 900, showConfirmButton: false });
                    }}
                        disabled={!product?.id}
                      >
                     Add to Cart
                      </Button>
                      {/* Optional: quick "Buy" or "Add to cart" button later */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Auth modals */}
      <AuthModals
        showLogin={showLogin}
        showRegister={showRegister}
        onCloseLogin={() => { setShowLogin(false); setPendingBooking(false); }}
        onCloseRegister={() => { setShowRegister(false); setPendingBooking(false); }}
        openRegisterFromLogin={() => { setShowLogin(false); setShowRegister(true); }}
        openLoginFromRegister={() => { setShowRegister(false); setShowLogin(true); }}
        navigation={false}
      />

      {/* Booking Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center gap-3">
            {/* tiny preview in modal */}
            <img
             src={product?.image && product.image !== "null"
                              ? `${process.env.REACT_APP_IMAGE_URL}/${product.image}`
                              : `${process.env.PUBLIC_URL}/assets/images/service/service-1.jpg`}
              alt={title}
              width={40}
              height={40}
              style={{ objectFit: "cover", borderRadius: 6, border: "1px solid #e9ecef" }}
              onError={(e) => {
                e.currentTarget.src = `${process.env.PUBLIC_URL}/assets/images/service/placeholder.png`;
              }}
            />
            <span>Book Product - {title}</span>
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleBook}>
          <Modal.Body>
            {bookingError && <Alert variant="danger">{bookingError}</Alert>}
            {bookingSuccess && <Alert variant="success">{bookingSuccess}</Alert>}

            <Row className="mb-3">
              <Form.Group as={Col} md="4">
                <Form.Label>Quantity</Form.Label>
                <Form.Control
                  type="number"
                  min={1}
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                  required
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="4">
                <Form.Label>Contact Name</Form.Label>
                <Form.Control
                  type="text"
                  value={contact.contact_name}
                  onChange={(e) => setContact({ ...contact, contact_name: e.target.value })}
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  value={contact.contact_phone}
                  onChange={(e) => setContact({ ...contact, contact_phone: e.target.value })}
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={contact.contact_email}
                  onChange={(e) => setContact({ ...contact, contact_email: e.target.value })}
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="6">
                <Form.Label>Address Line 1</Form.Label>
                <Form.Control
                  type="text"
                  value={contact.address_line1}
                  onChange={(e) => setContact({ ...contact, address_line1: e.target.value })}
                />
              </Form.Group>
              <Form.Group as={Col} md="6">
                <Form.Label>Address Line 2</Form.Label>
                <Form.Control
                  type="text"
                  value={contact.address_line2}
                  onChange={(e) => setContact({ ...contact, address_line2: e.target.value })}
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="4">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  value={contact.city}
                  onChange={(e) => setContact({ ...contact, city: e.target.value })}
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label>State</Form.Label>
                <Form.Control
                  type="text"
                  value={contact.state}
                  onChange={(e) => setContact({ ...contact, state: e.target.value })}
                />
              </Form.Group>
              <Form.Group as={Col} md="4">
                <Form.Label>Zipcode</Form.Label>
                <Form.Control
                  type="text"
                  value={contact.zipcode}
                  onChange={(e) => setContact({ ...contact, zipcode: e.target.value })}
                />
              </Form.Group>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button type="submit" variant="primary" disabled={bookingLoading}>
              {bookingLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" /> Booking…
                </>
              ) : (
                "Confirm Booking"
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default ProductDetails;
